import { GridRowClassNameParams, GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-premium'

export const getMtbRowClassNames = (
  params: GridRowClassNameParams,
  rowSelectionModel: GridRowSelectionModel,
  allRowIds: GridRowId[]
) => {
  const disabledRowIds = new Set()
  // const allProductIds = allRowIds
  if (Array.from(rowSelectionModel.ids).length > 0) {
    // 2. Parse out which selected IDs are “parents” vs “child tasks”
    //    - Parent IDs look like "ORG_<uuid>"
    //    - Child IDs look like "<PK>::<SK>", and SK starts with "MONTHLY_TASK_…"
    const selectedInfo = Array.from(rowSelectionModel.ids).map(id => {
      const [PK, SK] = (id as string).split('::')
      const isMonthlyTask = !!SK && SK.startsWith('MONTHLY_TASK_')
      const isProduct = !!SK && SK.startsWith('PRODUCT_')
      return { id, PK, SK, isMonthlyTask, isProduct }
    })
    // const hasParentSelected = selectedInfo.some(s => !s.isMonthlyTask)
    const hasParentSelected = selectedInfo.some(s => !s.isMonthlyTask && !s.isProduct)
    const hasChildSelected = selectedInfo.some(s => s.isMonthlyTask || s.isProduct)

    // 3. If any parent is selected, disable all child‐rows:
    if (hasParentSelected) {
      const childRowIds = allRowIds.filter(id => (id as string)?.includes('::'))
      childRowIds.forEach(id => disabledRowIds.add(String(id)))

      // monthlyTasks.forEach(task => {
      //   disabledRowIds.add(`${task.PK}::${task.SK}`)
      // })
      // products?.forEach(product => {
      //   disabledRowIds.add(`${product.PK}::${product.SK}`)
      // })
    }

    // 4. If any child is selected, disable all parent‐rows:
    if (hasChildSelected) {
      const parentRowIds = allRowIds.filter(id => !(id as string)?.includes('MONTHLY_TASK'))
      parentRowIds.forEach(id => disabledRowIds.add(String(id)))

      // formattedOrganizations.forEach(org => {
      //   disabledRowIds.add(`ORG_${org.org_uuid}`)
      // })
    }
  }

  const classNames = []
  if (params.row.isCreative) classNames.push('creative-row-border')
  if (params.row.isMarketing) classNames.push('marketing-row-border')
  if (params.row.isWebsite) classNames.push('website-row-border')
  if (params.row.highPrio) classNames.push('high-priority-row')
  if (params.row.isSubtask) classNames.push('subtask-row')
  if (params?.row?.isProduct) classNames.push('product-row')
  if (disabledRowIds.has(params.id)) classNames.push('disabled-selection')
  return classNames.join(' ')
}
